import ClipLoader from "react-spinners/ClipLoader";

function ClipLoaderComponent({size, customClass, border}) {

  return (
    <div className={`sweet-loading flex items-center ml-1 ${customClass ? customClass : ""}`}>
      <ClipLoader
        color={border ? border : "rgb(246 246 246 / 0.5)"}
        size={size}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}

export default ClipLoaderComponent;